<template>
  <div>
    <img :src="captImg" height="100%" v-show="captImg!=null"/>
    <canvas ref="canvas" id="canvas" width="1000" height="1350" v-show="false"/>
    <div class="row justify-center">
      <video ref="video" width="500" id="video" autoplay playsinline="true" :style="captImg!=null?'visibility:hidden;':''"/>
      <q-btn @click="changeCamera()" dense flat icon="flip_camera_android" round>&nbsp;Kamera wechseln</q-btn>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'photo-comp',
    props: {
      filename: {
        default: 'photo',
        type: String
      }
    },
    data() {
      return {
        video: {},
        canvas: {},
        captImg: null,
        stream: null,
        facingMode: "environment"
      }
    },

    methods: {
      async capture() {
        this.canvas = this.$refs.canvas
        var context = this.canvas.getContext("2d").drawImage(this.video, 0, 0, 1000, 1350);
        this.captImg = await new Promise(resolve => this.canvas.toBlob((blob) => {
          resolve(new File([blob], this.filename+".jpg", { type: "image/jpeg" }))
        }, 'image/jpeg'));
      },

      changeCamera(){
        this.stop()
        if(this.facingMode == "environment"){
          this.facingMode = "user"
        } else {
          this.facingMode = "environment"
        }
        this.start()
      },

      start() {
        this.video = this.$refs.video;
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
          navigator.mediaDevices.getUserMedia({video: {facingMode: {exact: this.facingMode}}})
            .then(stream => {
              this.stream = stream
              this.video.src = window.URL.createObjectURL(stream)
              this.video.play()
            })
            .catch(error => {
              navigator.mediaDevices.getUserMedia({video: true})
                .then(stream => {
                  this.stream = stream
                  this.video.srcObject = stream
                  this.video.play()
                })
                .catch(error => {
                  this.$emit('photoError', error)
                })
            })
            .finally(() => {
            })
        } else {
          console.error("Could not load user media (camera, microphone).")
        }
      },

      stop() {
        this.video.pause();
        this.video.src = ''
        for (let i = 0; i < this.stream.getTracks().length; i++) {
          this.stream.getTracks()[i].stop()
        }
      },

      async takePhoto() {
        await this.capture()
        this.$emit('photoTaken', this.captImg)
      }
    },

    beforeUnmount: function () {
      this.stop()
      this.eventBus.off('onTakePhoto', this.takePhoto)
    },

    mounted() {
      this.start()
      this.eventBus.on('onTakePhoto', this.takePhoto)
    }
  }
</script>

<style lang="sass">
</style>
